/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineIdUsersTeachers200,
  GetApiV1ClassroomdisciplineIdUsersTeachers401,
  GetApiV1ClassroomdisciplineIdUsersTeachers404,
  GetApiV1ClassroomdisciplineIdUsersTeachersPathParams,
  GetApiV1ClassroomdisciplineIdUsersTeachersQueryResponse,
} from "../../types/classPlanningPeopleController/GetApiV1ClassroomdisciplineIdUsersTeachers.ts";
import { classroomUserPersonListItemViewModelSchema } from "../classroomUserPersonListItemViewModelSchema.ts";

export const getApiV1ClassroomdisciplineIdUsersTeachersPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1ClassroomdisciplineIdUsersTeachersPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineIdUsersTeachers200Schema = z.array(
  z.lazy(() => classroomUserPersonListItemViewModelSchema),
) as unknown as ToZod<GetApiV1ClassroomdisciplineIdUsersTeachers200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineIdUsersTeachers401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdUsersTeachers401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassroomdisciplineIdUsersTeachers404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdUsersTeachers404>;

export const getApiV1ClassroomdisciplineIdUsersTeachersQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineIdUsersTeachers200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineIdUsersTeachersQueryResponse>;
